import React , { useContext } from 'react';
import { TablePagination } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import AdminNav from './adminNav';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import noData from './no-data.png'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { userContext } from '../../contexts/userContext';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';



import { useEffect, useState } from 'react';
import axios from 'axios';


export default function CompanyCard() {
  const { userId,userType } = useContext(userContext);
  const [selectedId, setSelectedId] = useState(userId)
  const navigate = useNavigate();
  const [rows,setRows]=useState([])
  const [id,setId]=useState('')
  const [message,setMessage]=useState('')
  const [deleteId,setDeleteId]=useState('')
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = useState('')
  const [users, setUsers] = useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const handleClickOpen = (id) => {
    setOpen(true);
    setDeleteId(id)
  };

  const handleClose = () => {
    setOpen(false);
  };

  function getAllUsers(params) {
    const token = localStorage.getItem("auth-token");
    axios
      .post(`/getUsers`, {
        type: '2'
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then((result) => {
        console.log('result', result);
        setUsers(result.data.Users)
      })
      .catch((err) => {
        // setMessage("No Category found")
      });
  }
  useEffect(() => {
    getAllUsers()
  }, [])

  const deleteItemById = (id) => {
    const token = localStorage.getItem("auth-token");
    axios.post(`/delete_Order`,{id:deleteId}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
        .then((result) => {
          getCompanyCards()
            setId(deleteId)
            handleClose()
        })
        .catch(() => {
            setMessage("No item found")
        });
}
function getCompanyCards(params) {
  const token = localStorage.getItem("auth-token");
  axios
  .post(`get_Order_by_status`,{
    type: '2',
    search: search,
    selectedUser: selectedId,
    page: page + 1, // MUI pages start at 0, API at 1
    limit: rowsPerPage
  }, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  })
  .then((result) => {
    console.log('result2345678',result.data.foundedData);
      setRows(result.data.foundedData)
      setTotalItems(result.data.pagination.totalItems);
      // setMessage("result")
  })
  .catch((err) => {
      setMessage("No Category found")
  });
}

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };
const handleChange = (event) => {
  setSearch(event.target.value);
};
useEffect(() => {
  getCompanyCards()
}, [page, rowsPerPage, search, selectedId]);
  return (
    <>
    <AdminNav />
    <Container className='' maxWidth="xl">
    <div className='title-with-search'>
        <h2>Company Cards</h2>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          {userType == 1 && <FormControl fullWidth className='select-type-menu new-seelect-user'>
            <InputLabel id="user-select-label">Select User</InputLabel>
            <Select
              labelId="user-select-label"
              id="user-select"
              value={selectedId}
              label="Select User"
              onChange={(e) => setSelectedId(e.target.value)}
            >
              <MenuItem value="">all</MenuItem>
              {users.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.userName} - {user.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>}
          <TextField id="outlined-basic" label="Enter name" variant="outlined" value={search}
                                  onChange={handleChange} />
        </div>
      </div>
      { rows.length == 0 ?
      <div className='image-no-data-div'>
     <img src={noData} alt="noData image" />
     </div>
      :
      <>
     
      
    <TableContainer component={Paper}>
     
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell >Name</TableCell>
            {/* <TableCell >Company</TableCell> */}
            <TableCell >phone</TableCell>
            {/* <TableCell >Image</TableCell> */}
            <TableCell >Created at</TableCell>
            <TableCell >End date</TableCell>
            <TableCell >Status</TableCell>
            <TableCell >Link</TableCell>
            <TableCell >QR Code</TableCell>
            <TableCell >Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell >{row.fullName}</TableCell>
              {/* <TableCell>{row.company== ''? '-' : row.company}</TableCell> */}
              <TableCell>{row?.mobileNumber?.length > 0 ?row?.mobileNumber[0].link :'-'}</TableCell>
              {/* <TableCell><img className='order-pending-image' src={row.mainUserImg} /></TableCell> */}
              <TableCell>{row.createdAt}</TableCell>
              <TableCell style={{color: row.expiredAt && row.expiredAt < new Date().toISOString().split('T')[0] ? 'red' : 'green'}}>{row.expiredAt ? row.expiredAt : '-'}</TableCell>
              <TableCell style={{color: row.orderEnabled ? 'green' : 'red'}}>{row.orderEnabled ? 'Active' : 'Expired'}</TableCell>
              <TableCell>{row.cardLink}</TableCell>
              <TableCell>{row.qr ? row.qr : '-'	}</TableCell>
              <TableCell >
                <div style={{display:'flex'}}>
                <DeleteIcon  onClick={() => handleClickOpen(row._id)} className='cancel-icon' />
                <EditIcon className='edit-icon' onClick={() => navigate(`/EditOrder?id=${row._id}`)()}  />
                </div>
                </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      
    </TableContainer></>}
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm to delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={() => deleteItemById()} >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Container>
    </>
  );
}